import { catchAllRoutes } from "@/routes/constants.mjs";
import type { BaseRoute } from "@/routes/routes.mjs";
import lazyFn from "@/util/lazy-fn.mjs";
import pathRegExp from "@/util/path-regexp.mjs";

const fetchStatic = lazyFn(() => import("@/game-deadlock/fetches/static.mjs"));
const fetchProfile = lazyFn(
  () => import("@/game-deadlock/fetches/profile-page.mjs"),
);
const fetchMatch = lazyFn(
  () => import("@/game-deadlock/fetches/match-page.mjs"),
);
const fetchHeroesStats = lazyFn(
  () => import("@/game-deadlock/fetches/heroes-page.mjs"),
);
const fetchHeroStats = lazyFn(
  () => import("@/game-deadlock/fetches/hero-page.mjs"),
);

const routes: BaseRoute[] = [
  // Stats Routes
  {
    path: pathRegExp("/deadlock"),
    redirect: "/deadlock/heroes",
  },
  {
    path: pathRegExp("/deadlock/heroes"),
    component: "game-deadlock/Heroes.tsx",
    fetchData: fetchHeroesStats,
  },

  // Hero Routes
  {
    path: pathRegExp("/deadlock/heroes/:heroId"),
    component: "game-deadlock/HeroOverview.tsx",
    fetchData: fetchHeroStats,
  },
  {
    path: pathRegExp("/deadlock/heroes/:heroId/items"),
    component: "game-deadlock/HeroItems.tsx",
    fetchData: fetchHeroStats,
  },
  {
    path: pathRegExp("/deadlock/heroes/:heroId/starting-items"),
    component: "game-deadlock/HeroItemsStarting.tsx",
    fetchData: fetchHeroStats,
  },
  {
    path: pathRegExp("/deadlock/heroes/:heroId/abilities"),
    component: "game-deadlock/HeroAbilities.tsx",
    fetchData: fetchHeroStats,
  },
  {
    path: pathRegExp("/deadlock/heroes/:heroId/matchups"),
    component: "game-deadlock/HeroMatchups.tsx",
    fetchData: fetchHeroStats,
  },
  {
    path: pathRegExp("/deadlock/heroes/:heroId/synergies"),
    component: "game-deadlock/HeroSynergies.tsx",
    fetchData: fetchHeroStats,
  },

  // Tierlist Routes
  {
    path: /\/deadlock\/tierlist/,
    redirect: "/deadlock/tier-list",
  },
  {
    path: /\/deadlock\/tier-list/,
    component: "game-deadlock/Tierlist.tsx",
    fetchData: fetchHeroesStats,
  },

  // Player Routes
  {
    path: /\/deadlock\/profile\/(?<steamId>[\w\-_.~]+)(?:\/(?<tab>[\w\-_.~]+))?/,
    component: "game-deadlock/Profile.tsx",
    fetchData: fetchProfile,
  },

  // Game flow
  {
    path: /\/deadlock\/in-game/,
    component: "game-deadlock/Tierlist.tsx",
    fetchData: fetchHeroesStats,
  },
  {
    path: pathRegExp("/deadlock/match/:matchId/:steamId"),
    component: "game-deadlock/Match.tsx",
    fetchData: fetchMatch,
  },

  {
    path: /\/deadlock\/faq/,
    component: "game-deadlock/FAQ.tsx",
    fetchData: () => {}, // noop
  },
];

routes.push({
  [catchAllRoutes]: routes,
  fetchData: fetchStatic,
});

export default routes;
